export const BOOKING_APPLICATION_QUESTION_OPTION_MODEL =
  "booking-application-question-option";

const bookingOptionModel = {
  option: ""
};

export default bookingOptionModel;
